module.exports = __webpack_public_path__ + "static/media/membership-farmer.db531ff3.png";